import React from "react";
import GreyTable from "../../../../components/Tables/GreyTable";
import { Col, Row, Container } from "react-bootstrap";

import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import { useTheme } from "../../../../Themecontext/Themecontext";

const columns = [
  {
    label: "Sr No",
    key: "srNo",
    align: "center",
  },
  {
    label: "Production Group",
    key: "Month",
    align: "left",
  },
  {
    label: "Quality",
    key: "quality",
    align: "left",
  },
  {
    label: "Inward",
    key: "Inward",
    align: "right",
    format: true,
  },
  {
    label: "Balance",
    key: "Balance",
    align: "right",
    format: true,
  },
  {
    label: "Charts",
    key: "charts",
    align: "center",
  },
];
const data = [
  {
    charts: true,
    srNo: 1,
    Month: "April",
    quality: "-",
    Variance: "-",
    Opening: 1250,
    Inward: 82.5,
    Balance: 103125,
  },
  {
    charts: true,
    srNo: 2,
    Month: "May",
    quality: "-",
    Variance: "-",
    Opening: 1380,
    Inward: 79.25,
    Balance: 109365,
  },
  {
    charts: true,
    srNo: 3,
    Month: "June",
    quality: "-",
    Variance: "-",
    Opening: 1425,
    Inward: 84.0,
    Balance: 119700,
  },
  {
    charts: true,
    srNo: 4,
    Month: "July",
    quality: "-",
    Variance: "-",
    Opening: 1310,
    Inward: 81.75,
    Balance: 107092.5,
  },
  {
    charts: true,
    srNo: 5,
    Month: "August",
    quality: "-",
    Variance: "-",
    Opening: 1490,
    Inward: 86.5,
    Balance: 128885,
  },
  {
    charts: true,
    srNo: 6,
    Month: "September",
    quality: "-",
    Variance: "-",
    Opening: 1560,
    Inward: 88.25,
    Balance: 137670,
  },
  {
    charts: true,
    srNo: 7,
    Month: "October",
    quality: "-",
    Variance: "-",
    Opening: 1440,
    Inward: 83.5,
    Balance: 120240,
  },
  {
    charts: true,
    srNo: 8,
    Month: "November",
    quality: "-",
    Variance: "-",
    Opening: 1525,
    Inward: 85.75,
    Balance: 130768.75,
  },
  {
    charts: true,
    srNo: 9,
    Month: "December",
    quality: "-",
    Variance: "-",
    Opening: 1610,
    Inward: 89.0,
    Balance: 143290,
  },
];

export default function TotalMeter() {
  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;

  return (
    <Container fluid style={{ padding: 0, margin: 0 }}>
      <Row
        className="justify-content-center"
        style={{ margin: 0, padding: 0 }}
      >
        <Col md={12} style={{ padding: 0, margin: 0 }}>
          <div
            style={{
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              overflow: "hidden",
              margin: 0,
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                padding: "20px 24px",
                margin: 0,
              }}
            >
              <h2
                className="text-xl font-semibold tracking-wide"
                style={{
                  fontSize: "18Px",
                  margin: 0,
                }}
              >
                MONTHWISE BALANCE DATA
              </h2>
              <p
                className="text-sm mt-1 mb-0"
              >
                Financial Year: (FY 2025-26)
              </p>
            </div>

            <div
              style={{
                backgroundColor: "rgb(255, 255, 255)",
                // padding: "20px",
                margin: 0,
              }}
            >
              <GreyTable columns={columns} data={data} />
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}